export const getPersonStructuredData = () => ({
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Babar Ali",
    "url": "https://babarali-dev.vercel.app/",
    "image": "https://babarali-dev.vercel.app//graph-profile-dev.jpg",
    "sameAs": [
      "https://www.linkedin.com/in/babar-ali2/",
      "https://github.com/BabarDeveloper/"
    ],
    "jobTitle": "Software Engineer",
    "worksFor": {
      "@type": "Organization",
      "name": "Generation Next Technology"
    },
    "description": "Software engineer with 5+ years of experience in full-stack development, AI automation, CRM/CMS solutions, and system integrations",
    "alumniOf": {
      "@type": "EducationalOrganization",
      "name": "AI Forge"
    },
    "award": [
      "AI Patent Winner 2023 - IP Hatch",
      "AI Forge Cohort 5 Alumnus",
      "Sky Labs Finalist 2022"
    ],
    "knowsAbout": [
      "Artificial Intelligence",
      "Machine Learning",
      "Full-Stack Development",
      "React",
      "TypeScript",
      "Python",
      "Enterprise Architecture"
    ]
  });
  
  export const getWebSiteStructuredData = () => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Babar Ali Portfolio",
    "url": "https://babarali-dev.vercel.app/",
    "description": "Portfolio of Babar Ali - Patent-winning full-stack developer",
    "publisher": {
      "@type": "Person",
      "name": "Babar Ali"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://babarali-dev.vercel.app//?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  });
  
  export const getServiceStructuredData = () => ({
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Software Development",
    "provider": {
      "@type": "Person",
      "name": "Babar Ali"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Global"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Development Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI Process Automation",
            "description": "Build custom LLM solutions and workflows to eliminate repetitive tasks"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "API Integration Solutions",
            "description": "Connect your systems seamlessly—from Xero to Shopify"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Intelligence Dashboards",
            "description": "Transform scattered data into actionable insights"
          }
        },
        {
            "@type": "Offer", 
            "itemOffered": {
                "@type": "Service",
                "name": "Predictive Analytics Models", 
                "description": "Forecast cash flow and business trends using machine learning on your Xero and CRM data"
            }
        }
      ]
    }
  });
  
  export const getCaseStudyStructuredData = (caseStudy: {
    title: string;
    description: string;
    image: string;
    url: string;
    datePublished: string;
  }) => ({
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": caseStudy.title,
    "description": caseStudy.description,
    "image": caseStudy.image,
    "url": caseStudy.url,
    "datePublished": caseStudy.datePublished,
    "author": {
      "@type": "Person",
      "name": "Babar Ali"
    },
    "publisher": {
      "@type": "Person",
      "name": "Babar Ali"
    }
  });
